import React, { Component } from "react";
import styled from "styled-components";
import moment from "moment";
import { StyledBaseTable, StyledLabelDollarFormatted, StyledLabelString } from './styledBaseTable';
import { LabelPercentFormatted, LabelDollarFormatted, LabelString } from '@loanbossinc/component-library';

const StyledAddressCell = styled.div`
  && {
    display: flex;
    flex-direction: column;
    border: none;  
  }
`;

const StyledLabelStringNoiDate = styled(LabelString)`
  && {
    font-family: Work Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    color: #5F6368;
  }
`;

export class PropertyActiveTable extends Component {
  columns = [
    {
      id: 'address'
      , label: 'ADDRESS'
      , path: 'addressData'
      , Cell: (value) => (
        <StyledAddressCell>
          <StyledLabelString value={value.address} />
          {value.noiAsOfDate && <StyledLabelStringNoiDate value={value.noiAsOfDate} />}
        </StyledAddressCell>
      )
    }
    , {
      id: 'marketValue'
      , label: 'MARKET VALUE'
      , path: 'marketValue'
      , Cell: (value) => <LabelDollarFormatted value={value} />
    }
    , {
      id: 'occupancyRaw'
      , label: 'OCCUPANCY'
      , path: 'occupancyRaw'
      , align: 'right'
      , Cell: (value) => <LabelPercentFormatted value={value} decimals={2} />
    }
    , {
      id: 'noi'
      , label: 'NOI'
      , path: 'noiActual'
      , Cell: (value) => <StyledLabelDollarFormatted decimals={2} value={value} />
    }
  ];

  mapProperties = () => {
    const { properties } = this.props;

    return properties.map(property => {
      const date = !!property.noiAsOfDate ? moment(property.noiAsOfDate, 'YYYY-MM-DD').format('MM/DD/YYYY') : null;
      const formattedDateString = !!date ? `Property data as of ${date}` : null;

      return {
        ...property
        , addressData: {
          address: property.address
          , noiAsOfDate: formattedDateString
        }
      }
    });
  }

  render() {
    const { properties } = this.props;
    if (!properties.length) return null;

    return (
      <StyledBaseTable
        columns={this.columns}
        onRowClick={item => this.props.redirect(item.id)}
        items={this.mapProperties()}
      />
    );
  }
}
